import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import Dashboard from "@/pages/Dashboard.vue";
import outlet from "@/pages/UserProfile.vue";
import Offers from "@/pages/TableList.vue";
import Privacy from "@/pages/UpgradeToPRO.vue";
import Welcome from "@/pages/Welcome.vue";
import End from "@/pages/End.vue";

const routes = [
  {
    path: "/dashboard",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "",
        name: "Your sales overview",
        component: Dashboard
      },
      {
        path: "outlet",
        name: "Your Outlet Profile",
        component: outlet
      },
      {
        path: "offers",
        name: "Offers",
        component: Offers
      },
      {
        path: "privacy",
        name: "Privacy Policy",
        component: Privacy
      },
      {
        path: "end",
        name: "Sign Out",
        component: End
      }
    ]
  },
  {
    path: "/privacy",
    component: Privacy
  },
  {
    path: "/",
    component: Welcome
  }
];

export default routes;
